import React from 'react';
import { imageUrl, imageSrcSet } from '../utils/imageUrl';

/**
 * An <img> that always ships the four things Lighthouse checks for: a
 * right-sized source, an explicit aspect ratio, a loading strategy, and an
 * off-main-thread decode.
 *
 * Pass `priority` for the one image that is the LCP element on a page — it
 * drops lazy loading and asks the browser to fetch it ahead of other subresources.
 * Everything else stays lazy.
 *
 * `width`/`height` are the intrinsic *ratio*, not the rendered size — CSS still
 * controls layout. They exist so the browser can reserve the right box before
 * the bytes arrive, which is what removes the layout shift.
 */
const SmartImage = ({
    src,
    alt = '',
    width = 800,
    height = 500,
    sizes = '100vw',
    priority = false,
    displayWidth = 960,
    quality = 78,
    className,
    style,
    onError,
    ...rest
}) => {
    if (!src) return null;

    const srcSet = imageSrcSet(src);

    return (
        <img
            src={imageUrl(src, displayWidth, { quality })}
            srcSet={srcSet}
            sizes={srcSet ? sizes : undefined}
            alt={alt}
            width={width}
            height={height}
            className={className}
            style={style}
            loading={priority ? 'eager' : 'lazy'}
            decoding={priority ? 'sync' : 'async'}
            fetchPriority={priority ? 'high' : undefined}
            onError={onError}
            {...rest}
        />
    );
};

export default SmartImage;
